import React from 'react';
import { QStack } from '@qualio/ui-components';
import ContentStep from './components/ContentStep';
import TasksStep from './components/TasksStepV2';
import { EventStep, User } from '../../types';
import FormStep from './components/FormStep';
import { useFormDetails } from '../../hooks/useEventForm';

type EventStepsProps = {
  eventId: number;
  eventDueDate?: string;
  steps: EventStep[];
  users: User[];
  contentStepAssignees: User[];
  refetch: () => void;
  userTZ: string;
};

const EventSteps: React.FC<EventStepsProps> = ({
  eventId,
  eventDueDate,
  steps,
  users,
  contentStepAssignees,
  refetch,
}) => {
  const lastUpdated = Math.max(...steps.map((step) => step.status_updated_at as number));
  const resolutionStep = steps[steps.length - 1];
  const resolutionStepId = resolutionStep?.id;
  const resolutionStepFormId = resolutionStep?.form_id;
  const resolutionStepType = resolutionStep?.type;
  const { data: form } = useFormDetails(eventId, resolutionStepId, resolutionStepFormId);
  const resolutionStepFormStatus = form?.status;

  const isResolutionStepForApproval =
    (resolutionStepType === 'form' && resolutionStepFormStatus === 'for_approval') ||
    (resolutionStepType === 'document' && resolutionStep?.document?.status_id === 'for_approval');

  return (
    <QStack w="100%" mr={6} mt={6} spacing={6}>
      {steps.map((step: EventStep) => {
        if (step.type === 'document') {
          return (
            <ContentStep
              isResolutionStepForApproval={isResolutionStepForApproval}
              key={`step-${step.id}`}
              step={step}
              assignees={contentStepAssignees}
              refetch={refetch}
              lastUpdated={lastUpdated}
              isResolutionStep={resolutionStep?.id === step.id}
            />
          );
        }
        if (step.type === 'actions') {
          return (
            <TasksStep
              isResolutionStepForApproval={isResolutionStepForApproval}
              key={`step-${step.id}`}
              step={step}
              refetch={refetch}
              eventDueDate={eventDueDate}
            />
          );
        }
        if (step.type === 'form') {
          return (
            <FormStep
              isResolutionStepForApproval={isResolutionStepForApproval}
              key={`step-${step.id}`}
              step={step}
              users={users}
              lastUpdated={lastUpdated}
              refetch={refetch}
              isResolutionStep={resolutionStep?.id === step.id}
            />
          );
        }
        return null;
      })}
    </QStack>
  );
};

export default EventSteps;
